import lodash from 'lodash'
import { useMemo } from 'react'

import { useField } from '../../../../1stlog-ui/src/components/Field'
import { TOrderEntryProduct } from '../types'
import useOrderEntry from '../useOrderEntry'
import { useProductsContext } from './ProductsContext'
import useProducts from './useProducts'

const useSelectedProduct = (
  propId?: string,
): TOrderEntryProduct | undefined => {
  const { isInternal } = useOrderEntry()

  const { products } = useProducts(propId)

  const productsContext = useProductsContext()

  const id = propId || lodash.get(productsContext, 'id')

  const fieldName = id ? `${id}.selectedProductId` : 'selectedProductId'

  const data = useField(id ?? 'noProductSelected', { ignorePrefix: true })

  const selectedProductId = useField(fieldName, {
    ignorePrefix: true,
  })

  const selectedProduct = useMemo(
    () =>
      lodash.find(
        products,
        (product) => String(product.id) === String(selectedProductId),
      ),
    [products, selectedProductId],
  )

  // FIXME: generate internal product properly (mainly for Confirmation)
  if (isInternal) {
    return {
      ...data,
      isInternal: true,
      isDispositionProduct: true,
      name: i18n.t('internal_dispatching', 'Interne Disponierung'),
    }
  }

  return selectedProduct
}

export default useSelectedProduct
